import React from 'react';

import { PublicOffer } from '../utils/files.js';
import TechSpecifications from '../tech-specifications.pdf';
import PrivacyPolicy from '../privacy-policy.pdf';

export default class OrderPayForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			drafts: false,
			legal: false,
			privacyPolicy: false,
		};
	}

	onCheckboxChange(e) {
		const { name, checked } = e.target;
		this.setState({
			...this.state,
			[name]: checked,
		});
	}

	render() {
		const { username, paymentId } = this.props;
		const publicOffer = username
			? `https://storage.yandexcloud.net/steklo24-landing/${username}/public-offer.pdf`
			: PublicOffer;

		const techSpecifications = username
			? `https://storage.yandexcloud.net/steklo24-landing/${username}/tech-specifications.pdf`
			: TechSpecifications;

		const privacyPolicy = username
			? `https://storage.yandexcloud.net/steklo24-landing/${username}/privacy-policy.pdf`
			: PrivacyPolicy;

		let isEnabledButton = true;

		Object.values(this.state).forEach((checked) => {
			if (!checked) {
				isEnabledButton = false;
			}
		});

		return (
			<form action={`/payments/${paymentId}`} method='POST'>
				<input
					className='form-checkbox'
					type='checkbox'
					id='drafts'
					name='drafts'
					value={true}
					onChange={(e) => this.onCheckboxChange(e)}
				/>
				<label className='form-label' htmlFor='drafts'>
					Состав заказа согласован
				</label>
				<input
					className='form-checkbox'
					type='checkbox'
					id='legal'
					name='legal'
					onChange={(e) => this.onCheckboxChange(e)}
				/>
				<label className='form-label' htmlFor='legal'>
					Cогласен с{' '}
					<a
						className='form-checkbox-link'
						target='_blank'
						rel='noopener noreferrer'
						href={publicOffer}
					>
						{' '}
						договором оферты
					</a>{' '}
					и{' '}
					<a
						className='form-checkbox-link'
						target='_blank'
						rel='noopener noreferrer'
						href={techSpecifications}
					>
						техническими условиями{' '}
					</a>
				</label>
				<input
					className='form-checkbox'
					type='checkbox'
					id='privacyPolicy'
					name='privacyPolicy'
					onChange={(e) => this.onCheckboxChange(e)}
				/>
				<label className='form-label' htmlFor='privacyPolicy'>
					{' '}
					Согласен с{' '}
					<a
						className='form-checkbox-link'
						target='_blank'
						rel='noopener noreferrer'
						href={privacyPolicy}
					>
						правилами обработки персональных данных{' '}
					</a>
				</label>
				<button
					className='form-submit-button'
					type='submit'
					disabled={!isEnabledButton}
				>
					Перейти к оплате
				</button>
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Order/OrderPayForm.jsx